import { InfoMessage } from 'ia-react-core';
import React, { FC } from 'react';
import { StyledText } from './ExcludedContractInformation.styles';

export interface ExcludedContractInformationProps { message: string }

const ExcludedContractInformation: FC<ExcludedContractInformationProps> = ({ message }) => (
  <InfoMessage>
    <StyledText>{message}</StyledText>
  </InfoMessage>
);
export default ExcludedContractInformation;
